import {URL_WEB_SERVICE_LOCAL_STORAGE, REGISTRAR_SOLICITUD_ENDPOINT} from 'constants/general'

export const REGISTER_REQUEST = `${URL_WEB_SERVICE_LOCAL_STORAGE}${REGISTRAR_SOLICITUD_ENDPOINT}`

export const GET_CPLANES = `${URL_WEB_SERVICE_LOCAL_STORAGE}get_cplanes`;